import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authReducer from './reducers/authSlice';


import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
 
});

// Persist config
const persistConfig = {
  key: 'root', // key for localStorage
  storage,     // define the storage (localStorage by default)
};
// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  // Disable serializable check for persist-related actions
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'], // Ignore persist actions
        ignoredActionPaths: ['payload.register', 'payload.rehydrate'], // Ignore specific paths
      },
    }),
});

const persistor = persistStore(store); // Create a persistor

export { store, persistor };
